import Header from "../../Components/Header/Header";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";
import { privateRequest } from "../../Components/commonApi/CommonApi";

import { createBrowserHistory } from "history";
import { Image_URL } from "../../Components/commonApi/CommonApi";
import { Helmet } from "react-helmet";
import API_CONFIG from "../../Components/commonApi/ApiConfig";

function ServiceProvider() {
  const [deletePackages, setDeletePackage] = useState([]);
  const [Provider, SetProvider] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [JobDAtabyspid, setJobDAtabyspid] = useState([]);
  const [search, setSearch] = useState("");

  const [penaltyData, setPenaltyData] = useState({
    SpId: "",
    Penalty: "",
    message: "",
    jobid: ""
  });

  const handleInputChange = (e) => {
    setPenaltyData({ ...penaltyData, [e.target.name]: e.target.value });
  };



  // const history = createBrowserHistory();
  // history.push('/package/edit')
  const GetProvider = async () => {
    try {
      const response = await privateRequest.get(`/ServiceProvider/GetProvider`);
      SetProvider(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const updateExpertType = async (id, expertType) => {
    try {
      const response = await privateRequest.post(
        `/ServiceProvider/UpdateExpertType/${id}`,
        { expertType }
      );
      if (!response?.data?.success) {
        throw new Error(response?.data?.message || "Failed to update");
      }
      SetProvider((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, expertType } : item
        )
      );
      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Expert type updated successfully",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error updating expert type:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Failed to update expert type",
      });
      GetProvider();
    }
  };

  const deleteProvider = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ServiceProvider/DeleteProvider/${_id}`
        );

        setDeletePackage(deletePackages.filter((item) => item._id !== _id));
        GetProvider();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };


  const submitPenalty = async () => {
    try {
      alert(penaltyData.jobid)

      const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

const raw = JSON.stringify({
  "SpId": penaltyData.SpId,
  "Penlty": penaltyData.Penalty,
  "message": penaltyData.message,
  "JobId": penaltyData.jobid
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch("https://api.experts4u.in/api/v2/PenltySp/createPenltySp", requestOptions)
  .then((response) => response.json())
  .then((result) => {console.log(result)
    Swal.fire("Success!", "Penalty added successfully.", "success");
  })
  .catch((error) => {console.error(error)
    Swal.fire("Error!", "Failed to add penalty.", "error");
  });
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error!", "Failed to add penalty.", "error");
    }
  };


  const getJObBySpID = async (id) => {
    try {

      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch(`${API_CONFIG.API_V2}/PenltySp/getJObsByjobAssignSProviderId/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {console.log(result)
          setJobDAtabyspid(result.data);
        })
        .catch((error) => console.error(error));
      
    } catch (error) {
      console.error("Error:", error);
      
    }
  }

  useEffect(() => {
    GetProvider();
  }, []);

  return (
    <>
      {Provider.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Service Provider</span>
                    </p>
                    <Link
                      to="/newprovider"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm dataTable no-footer "
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">SN</th>
                            <th scope="col">
                              <i className="fa fa-image"></i>
                            </th>
                            <th scope="col">Name</th>
                            <th scope="col">Expert Type</th>
                            <th scope="col">Category</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Password</th>
                            <th scope="col">City </th>

                            <th scope="col">State </th>

                            <th scope="col">Status</th>
                            <th scope="col">CreatedAt</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Provider?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.ProfilePhoto && (
                                  <img
                                    src={`${Image_URL}${item?.ProfilePhoto}`}
                                    alt="Category Image"
                                    className="rounded-pill"
                                    height="50"
                                    width="50"
                                  />
                                )}
                              </td>
                              <td className="align-center">{item?.Name}</td>
                              <td className="align-center">
                                <select
                                  className="form-control form-control-sm"
                                  style={{ minWidth: "130px" }}
                                  value={item?.expertType === "gold" ? "gold" : "prime"}
                                  onChange={(e) =>
                                    updateExpertType(item._id, e.target.value)
                                  }
                                >
                                  <option value="prime">Prime Expert</option>
                                  <option value="gold">Gold Expert</option>
                                </select>
                              </td>
                              <td className="align-center">
                                {item?.PCGroup &&
                                  item?.PCGroup.map((item, index) => (
                                    <p className="mb-0">
                                      {index + 1 + `${" "}` + item.PCGName}
                                    </p>
                                  ))}
                              </td>
                              <td className="align-center">
                                {item?.ContactNo}
                              </td>
                              <td className="align-center">{item?.Password}</td>
                              <td className="align-center">{item?.city}</td>
                              <td className="align-center">{item?.State}</td>

                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status?.toString() === "1"
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item?.Status?.toString() === "1"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              {/* </td> */}

                              <td className="align-center">
                                <p className="mb-0">{item.createdBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    onClick={() => {
                                      navigate("/editprovider", {
                                        state: item,
                                      });
                                    }}
                                    className="btn btn-primary btn-sm"
                                    data-toggle="modal"
                                    data-target="#childModal"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => deleteProvider(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                  <button
                                  className="bt  btn-primary"
                                  onClick={() => {
                                    navigate(`/penalty-sp/${item._id}`);
                                  }}
                                >
                                  <i className="fa fa-exclamation-triangle"></i>
                                </button>

                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      navigate(`/leaves/${item?.ContactNo}`);
                                    }}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </button>
                                
                                </div>
                              </td>

                             
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


       {/* Modal for Adding Penalty */}
       {showModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Penalty</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Service Provider ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="SpId"
                      value={penaltyData.SpId}
                      readOnly
                    />
                  </div>
                  <div className="form-group">
                    <label>Penalty Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      name="Penalty"
                      value={penaltyData.Penalty}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      value={penaltyData.message}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>
                  <div className="form-group">
                  <div className="form-group">
                    <label>Job ID</label>
                    <select
                      className="form-control"
                      name="jobId"
                      value={penaltyData.jobid}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Job ID</option>
                      {JobDAtabyspid?.map((job) => (
                        <option key={job._id} value={job.jobId}>
                          {job.jobId}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Search</label>
                    <input
                      type="text"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search Job ID"
                    />
                  </div>
                  <div className="form-group" style={{height: "100px", overflowY: "scroll"}}>
                    {search === "" ? (
                      <ul className="list-group">
                        {JobDAtabyspid?.map((job) => (
                          <li
                            key={job._id}
                            className="list-group-item"
                            style={{ cursor: "pointer" }}
                            onClick={() =>{
                              setPenaltyData({
                                ...penaltyData,
                                jobid: job.jobId,
                              });
                            }
                            }
                          >
                           <span className="badge">{job.jobId}</span> <span className="badge badge-primary">{job.payableCharges}</span> <span className="badge badge-success">{job.slotDate}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <ul className="list-group">
                        {JobDAtabyspid
                          ?.filter((job) =>
                            job.jobId.toLowerCase().includes(search.toLowerCase())
                          )
                          .map((job) => (
                            <li
                              key={job._id}
                              className="list-group-item"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setPenaltyData({
                                  ...penaltyData,
                                  jobid: job.jobId,
                                })
                              }
                            >
                             <span className="badge">{job.jobId}</span> <span className="badge badge-primary">{job.payableCharges}</span> <span className="badge badge-success">{job.slotDate}</span>
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={submitPenalty}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ServiceProvider;
